'use client';

import { CookiebotContext } from '@/app/components/CookiebotScript/CookiebotScript';
import Script from 'next/script';
import { useContext } from 'react';

const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID || '';

export const GtmScript = () => {
  const { areMarketingCookiesAllowed } = useContext(CookiebotContext);

  if (!areMarketingCookiesAllowed) {
    return null; // Do not render GTM if marketing cookies are not allowed
  }

  return (
    <>
      {/* GTM initialization script */}
      <Script id="gtm-init" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            'gtm.start': new Date().getTime(),
            event: 'gtm.js'
          });
        `}
      </Script>

      {/* GTM script loader */}
      <Script
        id="gtm-loader"
        strategy="afterInteractive"
        src={`https://www.googletagmanager.com/gtm.js?id=${GTM_ID}`}
      />
    </>
  );
};
